import { render, staticRenderFns } from "./home_dengfen.vue?vue&type=template&id=7afdb800&scoped=true&"
import script from "./home_dengfen.vue?vue&type=script&lang=js&"
export * from "./home_dengfen.vue?vue&type=script&lang=js&"
import style0 from "./home_dengfen.vue?vue&type=style&index=0&id=7afdb800&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afdb800",
  null
  
)

export default component.exports